<ng-container *ngIf="profilesLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_PROF'] || 'Loading profiles…' }}</p>
	</div>
</ng-container>

<ng-container *ngIf="profilesError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_PROF'] || 'Failed to load profiles.'
			}}</p>
	</div>
</ng-container>

<ng-container *ngIf="!profilesLoading && !profilesError">
	<div class="horizontal-scroll">
		<div class="flex justify-between items-center mb-3 px-2">
			<!-- Left: Create New button -->
			<button pButton type="button" icon="pi pi-plus"
				label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}"
				class="p-button-sm p-button-primary" (click)="createNewRecord()"></button>

			<!-- Right: Global filter -->
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
					placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}" class="p-inputtext-sm" />
			</span>
		</div>

			<ng-template #noProfiles>
				<div class="text-center p-4">
					<i class="pi pi-briefcase text-400" style="font-size: 3rem"></i>
					<p class="text-500 mt-2"> {{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_PROF'] || 'No profiles found.' }}</p>
				</div>
			</ng-template>
			<p-table 
					 #dt 
					 id = "tab_profile"
					 [value]="profiles" 
					 *ngIf="profiles && profiles.length > 0; else noProfiles" styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped"
					 [totalRecords] = "profiles.length"
					 dataKey="RecID" 
					 [tableStyle]="{ 'min-width': '50rem' }" 
					 [rows]="getCurrentPageSize( 0, profiles.length)"
					 [paginator]="true" 
					 [rowsPerPageOptions]="setPaginator(profiles.length)" 
					 [globalFilterFields]="globalFilterFields"
					 [paginatorDropdownAppendTo]="'body'"
					 (onPage) = "onRowsPerPageChange($event, 0, profiles.length)"
					 responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === profiles.length ? 'All' : item.value }}
			</ng-template>

			<!-- Header -->
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="RecID">
						{{ translateServ.dictionary['MAINT_CS_TIT_ID'] || 'ID' }}
						<p-sortIcon field="RecID"></p-sortIcon>
					</th>
					<th pSortableColumn="Profile">
						{{ translateServ.dictionary['PROFILE_NAME'] || 'Profile Name' }}
						<p-sortIcon field="Profile"></p-sortIcon>
					</th>
					<th pSortableColumn="IsActive">
						{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] || 'Status' }}
						<p-sortIcon field="IsActive"></p-sortIcon>
					</th>
					<th pSortableColumn="IsApproved">
						{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						<p-sortIcon field="IsApproved"></p-sortIcon>
					</th>
					<th pSortableColumn="Descr">
						{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						<p-sortIcon field="Descr"></p-sortIcon>
					</th>
					<th pSortableColumn="DateEntered">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_ENTERED'] || 'Created On' }}
						<p-sortIcon field="DateEntered"></p-sortIcon>
					</th>
					<th pSortableColumn="DateUpdated">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_UPDATED'] || 'Updated On' }}
						<p-sortIcon field="DateUpdated"></p-sortIcon>
					</th>
					<th>{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] || 'Actions' }}</th>
				</tr>
			</ng-template>

			<!-- Body -->
			<ng-template pTemplate="body" let-profiler>
				<tr>
					<td>{{ profiler.RecID }}</td>
					<td>{{ profiler.Profile }}</td>

					<!-- Status -->
					<td>
						<p-tag
							[value]="profiler.IsActive === 1 ? (translateServ.dictionary['ACTIVE'] || 'Active') : (translateServ.dictionary['INACTIVE'] || 'Inactive')"
							[severity]="getProfilerSeverity(profiler.IsActive)"
							(click)="toggleProfilerStatus(profiler, true)">
						</p-tag>
					</td>

					<!-- Approved -->
					<td>
						<p-tag
							[value]="profiler.IsApproved === 1 ? (translateServ.dictionary['APPROVED'] || 'Approved') : (translateServ.dictionary['NOT_APPROVED'] || 'Not Approved')"
							[severity]="profiler.IsApproved === 1 ? 'success' : 'warning'"
							(click)="toggleProfilerStatus(profiler, false)">
						</p-tag>
					</td>

					<!-- Description with tooltip -->
					<td>
						<span *ngIf="profiler.Descr; else noDescr" [pTooltip]="profiler.Descr" tooltipPosition="top">
							{{ profiler.Descr.length > 20 ? (profiler.Descr | slice:0:20) + '…' : profiler.Descr }}
						</span>
						<ng-template #noDescr><span class="text-gray-400">—</span></ng-template>
					</td>

					<!-- Dates -->
					<td>{{ profiler.DateEntered ? (profiler.DateEntered | date:'mediumDate') : 'N/A' }}</td>
					<td>{{ profiler.DateUpdated ? (profiler.DateUpdated | date:'mediumDate') : 'N/A' }}</td>

					<!-- Actions -->
					<td>
						<div class="flex gap-2">
							<!-- Edit -->
							<button pButton icon="pi pi-pencil" (click)="editProfiler(profiler)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>

							<!-- Delete -->
							<button pButton icon="pi pi-trash" (click)="confirmDelete(profiler)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_DELETE']" tooltipPosition="top">
							</button>
						</div>
					</td>
				</tr>
			</ng-template>

			   <!-- Empty Message -->
			   <ng-template pTemplate="emptymessage">
				   <tr>
					   <td [attr.colspan]="globalFilterFields.length + 2" class="text-center p-4">
						   <i class="pi pi-tag text-400" style="font-size: 3rem"></i>
						   <p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_PROF'] || 'No profiles found.' }}</p>
					   </td>
				   </tr>
			   </ng-template>

			<ng-template #noProfiles>
				<div class="text-center p-4">
					<i class="pi pi-tag text-400" style="font-size: 3rem"></i>
					<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_PROF'] || 'No profiles found.' }}</p>
				</div>
			</ng-template>

		</p-table>
	</div>
</ng-container>